import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  position: absolute;
  align-items: flex-end;
  flex-direction: column;
  top: 60px;
  right: 0;
  left: 0;
  bottom: 0;
`;
